'use strict';

(function () {
	angular.module('onboarding.services')
		.factory('onboardHttpInterceptor', onboardHttpInterceptor);

	var subjectObserverMessagesService, observerService, subjectMessages, $window, appConfig;

	onboardHttpInterceptor.$inject = ['$q', '$rootScope', 'subjectObserverMessagesService', 'observerService', '$window', 'appConfig'];

	function onboardHttpInterceptor($q, $rootScope, _subjectObserverMessagesService_, _observerService_, _$window_, _appConfig_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		subjectMessages = subjectObserverMessagesService.getSubjectMessages();
		$window = _$window_;
		appConfig = _appConfig_;

		return {
			response: response,
			responseError: responseError,
			request: request
		};

		function response(httpResponse) {
			var headers = httpResponse.headers();
			var config = httpResponse.config;
			var byPassEnabled = config && config.bypassErrorsInterceptor;

			if (headers.isexception) {
				if (!byPassEnabled)
					observerService.sendMessageToSubject($rootScope, subjectMessages.COB_SUBJECT_HTTP_ERROR_500, httpResponse.data);
				
				return $q.reject(httpResponse.data);
			}

			return httpResponse || $q.when(httpResponse);
		}

		function responseError(rejection) {
			if (rejection.status === 401) {
				observerService.sendMessageToSubject($rootScope,
					subjectMessages.COB_SUBJECT_HTTP_ERROR_401,
					rejection.data);
			}
			if (rejection.status === 403) {
				$rootScope.authenticationService.logout();
			}
			if (rejection.status === 404) {
				observerService.sendMessageToSubject($rootScope, subjectMessages.COB_SUBJECT_HTTP_ERROR_404, rejection.data);
			}
			if (rejection.status === 500 || rejection.status === 501 || rejection.status === 502 || rejection.status === 504) {
				if (rejection.config.url.indexOf('usurp') !== -1) {
					return;
				}

				var config = rejection.config;
				var byPassEnabled = config && config.bypassErrorsInterceptor;

				if (!byPassEnabled) {
					var errorData = (rejection.data) ? rejection.data
						: { message: 'We\'re sorry, an unexpected error has occurred. Please retry your request in a few minutes.', category: 'Unexpected' };
					observerService.sendMessageToSubject($rootScope, subjectMessages.COB_SUBJECT_HTTP_ERROR_500, errorData);
				}
			}

			return $q.reject(rejection);
		}

        
		function request(config) {
			if (config.url.indexOf('.html') !== -1) {
				config.url = config.url + '?v=' + appConfig.appVersion;
			}

			return config;
		}
	}
})();
